import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getAuthTokenRequest = () => {
  const url = `${apiURl}/authenticate?Company=Kaleia&Nick=KaleiaWWW&Pass=0663da53e5c1d2dcf16690b1003393a6`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetchAndReturn(url, parameters);
};

const getAdminTokenRequest = (company, nick, password) => {
  const url = `${apiURl}/authenticate?Company=${company}&Nick=${nick}&Pass=${password}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return fetchAndReturn(url, parameters);
};

const getCompaniesRequest = (token) => {
  const url = `${apiURl}/companies`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const getCompaniesDetailsRequest = (token, id) => {
  const url = `${apiURl}/companies/${id}`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export {
  getAuthTokenRequest,
  getAdminTokenRequest,
  getCompaniesRequest,
  getCompaniesDetailsRequest,
};
